// URL del gateway WebSocket (dhk8-pos-realtime) para el comensal.
//
// El gateway WS SÓLO está expuesto en el host `api.<dominio>` (ingress
// dhk8-pos-realtime, con proxy-timeouts largos para WS). El guest corre en
// `guest.<dominio>`, así que cruzamos de host: guest.nintaigo.com → api.nintaigo.com.
// El WebSocket NO está sujeto a same-origin para la conexión; el token va en
// `?token=` (no cookies), así que el cruce de host es seguro.

export function guestRealtimeWsUrl(): string {
  const override = import.meta.env['VITE_REALTIME_WS_URL'] as string | undefined
  if (override && override.length > 0) return override
  if (typeof window === 'undefined') return ''
  const { protocol, host } = window.location
  const scheme = protocol === 'https:' ? 'wss' : 'ws'
  // guest.<dominio> → api.<dominio>. Si no hay prefijo `guest.` (dev/localhost),
  // usamos el mismo host — en dev el WS puede no resolver y el tracker cae al
  // poll REST (fallback), sin romper nada.
  const apiHost = host.startsWith('guest.') ? `api.${host.slice('guest.'.length)}` : host
  return `${scheme}://${apiHost}/v1/dhk8-pos-realtime/ws`
}
